import { useReveal } from "../hooks/useReveal";
import { useSiteCopy } from "../context/SiteCopyContext";
import { CopyText } from "./CopyText";
import { getAtPath } from "../lib/siteCopyPaths";
import { NewsletterForm } from "./forms/NewsletterForm";
import { ContactForm } from "./forms/ContactForm";

export function Contact() {
  const ref = useReveal<HTMLElement>();
  const { copy } = useSiteCopy();
  return (
    <section className="section section-contact" id="contact" ref={ref}>
      <div className="contact-grid">
        <div className="contact-wa">
          <div className="sec-eyebrow">
            <em>
              <CopyText path="contact.waEyebrow" as="span" />
            </em>
          </div>
          <h2 className="sec-title sec-title-sm">
            <CopyText path="contact.waTitle" as="span" />
          </h2>
          <p className="lede-serif">
            <CopyText path="contact.waLede" as="span" />
          </p>
          <a className="wa-card" href="https://wa.me/256779809343" target="_blank" rel="noopener" style={{ marginBottom: 32 }}>
            <div className="wa-icon">
              <svg viewBox="0 0 32 32" width="28" height="28">
                <path fill="currentColor" d="M16 3C8.8 3 3 8.8 3 16c0 2.3.6 4.4 1.7 6.3L3 29l6.9-1.7C11.7 28.4 13.8 29 16 29c7.2 0 13-5.8 13-13S23.2 3 16 3zm7.4 18.3c-.3.9-1.6 1.7-2.3 1.8-.6.1-1.4.1-2.2-.1-.5-.2-1.2-.4-2-.8-3.6-1.5-5.9-5.2-6.1-5.4-.2-.2-1.5-2-1.5-3.8s.9-2.7 1.3-3.1c.3-.3.7-.4 1-.4h.7c.2 0 .5-.1.8.6.3.7 1 2.4 1.1 2.6.1.2.1.4 0 .6-.1.2-.2.4-.4.6-.2.2-.4.5-.5.6-.2.2-.4.4-.2.7.2.4.9 1.5 2 2.4 1.4 1.2 2.5 1.6 2.9 1.8.4.2.6.2.8-.1.2-.3.9-1 1.1-1.4.2-.4.4-.3.7-.2.3.1 1.9.9 2.3 1.1.3.2.6.2.6.4.1.1.1.9-.2 1.8z" />
              </svg>
            </div>
            <div className="wa-text">
              <div className="wa-k">{String(getAtPath(copy, "contact.waCardK") ?? "")}</div>
              <div className="wa-v">{String(getAtPath(copy, "contact.waCardV") ?? "")}</div>
            </div>
            <div className="wa-arrow">→</div>
          </a>

          <div className="contact-form-wrap">
            <h3 className="sec-title sec-title-sm" style={{ fontSize: "clamp(22px, 2.4vw, 28px)", margin: "0 0 16px" }}>
              <CopyText path="contact.formHeading" as="span" />
            </h3>
            <ContactForm />
          </div>
        </div>

        <div className="contact-news">
          <div className="sec-eyebrow">
            <em>
              <CopyText path="contact.newsEyebrow" as="span" />
            </em>
          </div>
          <h2 className="sec-title sec-title-sm">
            <CopyText path="contact.newsTitle" as="span" />
          </h2>
          <p className="lede-serif">
            <CopyText path="contact.newsLede" as="span" />
          </p>
          <NewsletterForm />
          <div className="socials">
            <a href="https://x.com/together_heaven" target="_blank" rel="noopener">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
              <span>@together_heaven</span>
            </a>
            <a href="https://facebook.com/togetherinheaven" target="_blank" rel="noopener">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95 0-5.52-4.48-10-10-10z" />
              </svg>
              <span>/togetherinheaven</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
